
import vue from 'vue'
import Toast from 'vux/src/components/toast/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'

import {
initWxJSSDK,
loadMapMarkerTerminals,
getTerminalDetail,
openDoor,
getOpenDoorStatus,
getTerminalList
} from '../../common/js/api.js'
import { getCookie, setCookie, removeCookie } from '../../common/js/utils.js'
import { TMap } from '../../common/js/map.js'

export default {
directives: {
TransferDom
},
components: {
Toast,
Picker,
PopupPicker,
XHeader,
Box,
XButton,
XInput,
Group,
CellBox,
Cell,
Scroller,
Icon,
Search,
Flexbox,
FlexboxItem,
TransferDom,
Radio,
Popup,
Grid,
GridItem,
GroupTitle
},
methods: {
init() {
let self = this
if (self.isInit) {
return
}
if (self.list.length == 0 || !self.myLocation) {
return
}
self.lineCount = 0

for (var i = 0; i < self.list.length; i++) {
let directionsService = new qq.maps.DrivingService({
complete: function(response) {


self.lineCount++
if (response.detail.bounds.lat.minY < self.mapBounds.lat.minY) {
self.mapBounds.lat.minY = response.detail.bounds.lat.minY
}
if (response.detail.bounds.lat.maxY > self.mapBounds.lat.maxY) {
self.mapBounds.lat.maxY = response.detail.bounds.lat.maxY
}
if (response.detail.bounds.lng.minX < self.mapBounds.lng.minX) {
self.mapBounds.lng.minX = response.detail.bounds.lng.minX
}
if (response.detail.bounds.lng.maxX > self.mapBounds.lng.maxX) {
self.mapBounds.lng.maxX = response.detail.bounds.lng.maxX
}
let directions_routes = response.detail.routes
let route = directions_routes[0]
let polyline = new qq.maps.Polyline({
path: route.path,
strokeColor: self.randomColor(), //'#3893F9',
strokeWeight: 3,
map: self.map
})
if (self.lineCount == self.list.length) {
self.resetBound()



}
}
})
self.directionsServiceList.push(self.directionsService)
directionsService.setPolicy(qq.maps.DrivingPolicy['LEAST_TIME'])
directionsService.search(
new qq.maps.LatLng(
self.myLocation.latitude,
self.myLocation.longitude
),
new qq.maps.LatLng(self.list[i].latitude, self.list[i].longitude)
)




}

for (var i = 0; i < self.list.length; i++) {
self.terminals.push({
gps: new qq.maps.LatLng(
self.list[i].latitude,
self.list[i].longitude
),
location: self.list[i].location,
status: self.list[i].status,
online: self.list[i].extInfo.online,
useAll: self.list[i].useAll,
terminalId: self.list[i].sid,
terminalCode: self.list[i].terminalId,
organId: self.list[i].organId ? self.list[i].organId : ''
})
}
if (self.terminals) {
for (i in self.terminals) {

var icon = '/static/images/box_online.png'
if (self.terminals[i].online == 0) {
icon = '/static/images/box_offline.png'
} else if (self.terminals[i].useAll == 1) {
icon = '/static/images/box_full.png'
}
self.addMarker(
self.terminals[i],
new qq.maps.MarkerImage(
icon,
new qq.maps.Size(32, 32),
new qq.maps.Point(0, 0),
new qq.maps.Point(16, 32),
new qq.maps.Size(32, 32)
)
)
}
}


var opt = {
position: new qq.maps.LatLng(
self.myLocation.latitude,
self.myLocation.longitude
),
map: self.map
}
if (icon) {
opt.icon = new qq.maps.MarkerImage(
'/static/images/icons/i_start.png',
new qq.maps.Size(32, 32),
new qq.maps.Point(0, 0),
new qq.maps.Point(32, 32),
new qq.maps.Size(32, 32)
)

}
var marker = new qq.maps.Marker(opt)

self.isInit = true
},
randomColor() {
return '#' + Math.floor(Math.random() * 0xffffff).toString(16)
},
resetBound() {
let self = this






self.map.fitBounds(
new qq.maps.LatLngBounds(
new qq.maps.LatLng(self.mapBounds.lat.minY, self.mapBounds.lng.minX),
new qq.maps.LatLng(self.mapBounds.lat.maxY, self.mapBounds.lng.maxX)
)
)
},
getTerminalList() {
let self = this
getTerminalList().then(function(data) {
self.list = data.Content
for (var i = 0; i < self.list.length; i++) {
self.list[i].terminalInfo = '回收箱:' + self.list[i].location
self.list[i].status =
'状态:' + (self.list[i].useAll == 1 ? '已满' : '未满')
}
setTimeout(self.init, 500)
})
},
loadMapMarkerTerminals() {
let self = this
loadMapMarkerTerminals().then(function(data) {
self.dataSource = data.Content
for (var i = 0; i < data.Content.length; i++) {
self.terminals.push({
gps: new qq.maps.LatLng(data.Content[i].lat, data.Content[i].lng),
location: data.Content[i].location,
status: data.Content[i].status,
useAll: data.Content[i].useAll,
terminalId: data.Content[i].terminalId,
terminalCode: data.Content[i].terminalCode,
organId: data.Content[i].organId ? data.Content[i].organId : ''
})
}
if (self.terminals) {
for (i in self.terminals) {

var icon = '/static/images/box_online.png'
if (self.terminals[i].status == 0) {
icon = '/static/images/box_offline.png'
} else if (self.terminals[i].useAll == 1) {
icon = '/static/images/box_full.png'
}
self.addMarker(
self.terminals[i],
new qq.maps.MarkerImage(
icon,
new qq.maps.Size(32, 32),
new qq.maps.Point(0, 0),
new qq.maps.Point(16, 32),
new qq.maps.Size(32, 32)
)
)
}
}
})
},
initLocation() {
let self = this
self.$wechat.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res)
},
success: function(res) {
var latitude = res.latitude 
var longitude = res.longitude 
var speed = res.speed 
var accuracy = res.accuracy 
setCookie('latitude', latitude)
setCookie('longitude', longitude)
self.myLocation = { latitude: latitude, longitude: longitude }
self.center = new qq.maps.LatLng(latitude, longitude)
self.init()
self.setCenter(self.center)



}
})
},
setCenter(_center) {
try {
this.map.panTo(_center)
} catch (e) {}
},
addMarker(terminal, icon) {
let self = this
var opt = {
position: terminal.gps,
map: self.map
}
if (icon) {
opt.icon = icon
}
var marker = new qq.maps.Marker(opt)
marker.terminalId = terminal.terminalId
marker.terminalCode = terminal.terminalCode
marker.location = terminal.location
marker.status = terminal.status
marker.useAll = terminal.useAll
marker.organId = terminal.organId
marker.lat = terminal.gps.lat
marker.lng = terminal.gps.lng
qq.maps.event.addListener(marker, 'click', function(event) {

})

},
viewDetail(t) {
let self = this
self.currentTerminal = t
if (self.currentTerminal.status == 0) {
self.currentTerminal.statusText = '离线'
} else if (self.currentTerminal.useAll == 1) {
self.currentTerminal.statusText = '箱满'
} else {
self.currentTerminal.statusText = '正常'
}
self.isPopup = true
},
openDoor() {
let self = this
this.$vux.confirm.show({

title: '提醒您',
content: '确定打开回收箱的所有门？',
onCancel() {},
onConfirm() {
self.confirmOpenDoor()
}
})
},
confirmOpenDoor() {
let self = this
self.times = 0
self.$vux.loading.show({
text: '正在打开...'
})
openDoor({
data: {
terminalId: self.currentTerminal.sid,
latitude: self.myLocation.latitude,
longitude: self.myLocation.longitude
}
}).then(function(data) {
self.serialNumber = data.Content
setTimeout(self.refreshSerialNumber, 3000)
})
},
refreshSerialNumber() {
let self = this
self.times++
if (self.times > 15) {
self.$vux.loading.hide()
self.$vux.toast.text('开门指令超时未响应！')
return
}
getOpenDoorStatus({
data: {
terminalId: self.currentTerminal.terminalId,
serialNumber: self.serialNumber
}
}).then(
function(data) {
if (data.Message == '1') {
setTimeout(self.refreshSerialNumber, 2000)
} else {
self.$vux.loading.hide()
self.$vux.toast.text('门已打开')
}
},
function(data) {

}
)
},








route() {
let self = this
self.$wechat.openLocation({
latitude: self.currentTerminal.lat, // 纬度，浮点数，范围为90 ~ -90
longitude: self.currentTerminal.lng, // 经度，浮点数，范围为180 ~ -180。
name: '回收箱位置', // 位置名
address: self.currentTerminal.location, // 地址详情说明
scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
infoUrl: '' 
})
},
routeTerminal(latitude, longitude, address) {
let self = this
self.$wechat.openLocation({
latitude: latitude, // 纬度，浮点数，范围为90 ~ -90
longitude: longitude, // 经度，浮点数，范围为180 ~ -180。
name: '回收箱位置', // 位置名
address: location, // 地址详情说明
scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
infoUrl: '' 
})
},
openTerminal(idx) {
let self = this
self.viewDetail(self.list[idx])
self.listShow = false
},
openOrders(idx) {
let self = this
self.$router.push({
path: '/support/orderList',
query: { sid: self.list[idx].sid }
})
}
},
watch: {
listShow: function(val) {
this.isPopup = !val
if (val) {
}
},
isPopup: function(val) {
this.listShow = !val
}
},
data() {
return {
lineCount: 0,
mapBounds: { lat: { minY: 999, maxY: 0 }, lng: { minX: 999, maxX: 0 } },
myLocation: null,
center: {},
map: {},
directionsService: null,
directionsServiceList: [],
isInit: false,
dataSource: [],
terminals: [],
currentTerminal: { extInfo: {} },
isPopup: false,
listShow: true,
serialNumber: 0,
times: 0,
list: []
}
},
created() {},
mounted() {
let self = this
initWxJSSDK()
var longitude = getCookie('longitude')
var latitude = getCookie('latitude')
if (!latitude) {
latitude = 39.916527
}
if (!longitude) {
longitude = 116.397128
}
TMap('').then(qq => {
self.map = new qq.maps.Map(document.getElementById('map-container'), {

center: new qq.maps.LatLng(latitude, longitude),
zoom: 6,
disableDefaultUI: true
})


})
vue.wechat.ready(function(res) {
self.initLocation()
})

self.getTerminalList()
}
}



// WEBPACK FOOTER //
// ./src/components/support/TerminalList.vue